import classNames from "classnames"

import getRoundedClasses from "./getRoundedClasses"
import { Rounded } from "./types"

export interface ImageProps {
  aspectRatio?: "auto" | "16/9" | "4/3" | "1/1"
  alt: string
  rounded?: Rounded
  src: string
}

export const Image = ({
  aspectRatio = "auto",
  alt,
  rounded = false,
  src,
}: ImageProps) => {
  return (
    <img
      alt={alt}
      className={classNames(
        "block",
        "w-full",
        rounded && getRoundedClasses(rounded),
      )}
      src={src}
      style={{ aspectRatio }}
    />
  )
}
